import React, { useContext } from 'react'
import { Box, RadioButtonGroup, Text } from '@usap/uicomponents'
import { SearchContext } from '../../common/context/SearchContextProvider'

import seoIDs from '../../../../config/seoIds'

import { GTM } from '../../../helpers'
import { LocalContext } from '../../../helpers/useLocalContext'
import PageTypeIdentifier from '../../../helpers/PageTypeIdentifier'

const sortFlag = 'sort'
const defaultSort = 'best-match'

const itemPerPage = 'itemperpage'
const defaultPageItems = 15

const currentPage = 'currentpage'
const defaultCurrentPage = '1'

export default function Mobile(props) {
  const { toggleItemsPerPage } = props
  const {
    searchState: { products, sortOptions },
  } = useContext(SearchContext)
  const { resultCount: numberOfProducts = 0 } = products

  const { localContext } = useContext(LocalContext)
  const { history } = localContext

  const urlParams = new URLSearchParams(
    __BROWSER__ ? window.location.search : history.location.pathname,
  )

  const sortSelected = urlParams.get(sortFlag) || defaultSort
  const pageItemsCount = Number(urlParams.get(itemPerPage) || defaultPageItems)
  const pageNumber = Number(urlParams.get(currentPage) || defaultCurrentPage)

  const hasMinNumberOfProducts = pageItemsCount > numberOfProducts
  const shownRecords = hasMinNumberOfProducts
    ? numberOfProducts
    : pageItemsCount

  const { searchResultsTabView } = GTM
  return (
    <Box
      id="sortByComponent"
      pad="medium"
      border={{ side: 'bottom', size: 'xsmall', color: 'grey' }}
    >
      <Box id="sortByTextWrapper" margin={{ bottom: 'medium' }}>
        <Text id="sortByText" weight="bold" color="dark-2">
          Sort by
        </Text>
      </Box>

      <RadioButtonGroup
        id={seoIDs.sortByFilter}
        style={{
          fontSize: '14px',
          color: '#333333',
        }}
        name="doc"
        options={sortOptions}
        value={sortSelected}
        onChange={event => {
          const selectedSortOption = sortOptions.find(obj => obj.value === event.target.value)
          const categories = `Sort by ${selectedSortOption.label}`

          PageTypeIdentifier.setIdentifier(window?.pageType || null)

          searchResultsTabView({
            searchResultsCount: numberOfProducts,
            categories,
            itemsPerPageSelection: shownRecords,
            resultPageNumberSelection: pageNumber,
            clickText: selectedSortOption.label,
          })

          toggleItemsPerPage('sort', selectedSortOption.value)
        }}
      />
    </Box>
  )
}
